import * as introJs from 'intro.js/intro.js';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { HelpTextService } from 'src/app/data/service/help-text.service';
import { IntroJsService, IntroSlide, TutorialStatus } from 'src/app/data/service/intro-js.service';

@Component({
  selector: 'app-help-bubble',
  templateUrl: './help-bubble.component.html',
  styleUrls: ['./help-bubble.component.scss'],
})
export class HelpBubbleComponent implements OnInit, OnChanges {

  @Input() pageKey: string;

  showHelp = false;
  introJS = introJs();
  sanitizeContent: any;
  tutorials: IntroSlide[] = [];

  constructor(
    private helpTextSvc: HelpTextService,
    private introJsSvc: IntroJsService,
    private domSanitizer: DomSanitizer,
  ) { }

  async ngOnInit() {
  }

  async ngOnChanges() {
    await this.checkForHelp();
    await this.checkForTutorial();
    this.showHelp = false;
  }

  determineFunctionCall() {
    if (this.sanitizeContent) {
      this.showHelp = !this.showHelp;
    } else {
      this.showTutorial();
    }
  }

  async checkForHelp() {
    const htmlContent = await this.helpTextSvc.fetchHelpText(this.pageKey);
    if (htmlContent != null) {
      this.sanitizeContent = this.domSanitizer.bypassSecurityTrustHtml(htmlContent);
    } else {
      this.sanitizeContent = null;
    }
  }

  async checkForTutorial() {
    const tutorials = await this.introJsSvc.fetchTutorials(this.pageKey);
    if (tutorials) {
      this.tutorials = tutorials;
      const status = this.introJsSvc.getTutorialStatus(this.pageKey);
      const statusToSkip = [TutorialStatus.started, TutorialStatus.exited, TutorialStatus.complete];
      setTimeout(() => {
        if (!statusToSkip.includes(status)) {
          this.showTutorial();
        }
      }, 500);
    } else {
      this.tutorials = [];
    }
  }

  showTutorial() {
    const elements: { element: Element, position: string, intro: string }[] = [];
    this.tutorials.forEach(element => {
      const domElement = element.elementId ?
        document.getElementById(element.elementId) :
        document.getElementsByClassName(element.className)[0];

      if (!domElement) {
        return;
      }

      // we use [hidden] to hide some elements for binding reasons, don't show tutorials for hidden elements
      const isVisible = (domElement as HTMLElement).offsetWidth > 0 && (domElement as HTMLElement).offsetHeight > 0;
      if (domElement && isVisible) {
        elements.push({
          element: domElement,
          intro: element.htmlContent,
          position: element.position ?? null
        });
      }
    });

    //This fixes the element off-screen not being properly shown
    this.introJS.onchange((targetElement) => {
      targetElement.scrollIntoView(false);
    });

    this.introJS.setOptions({ steps: [...elements] }).start();
    this.introJsSvc.setTutorialStatus(this.pageKey, TutorialStatus.started);
    this.introJS.onexit(() => {
      if (this.introJsSvc.getTutorialStatus(this.pageKey) !== TutorialStatus.complete) {
        this.introJsSvc.setTutorialStatus(this.pageKey, TutorialStatus.exited);
      }
    });
    this.introJS.oncomplete(() => {
      this.introJsSvc.setTutorialStatus(this.pageKey, TutorialStatus.complete);
    });
  }

}
